module.exports = __webpack_public_path__ + "img/whitepaper.e1db0c96.png";